import React, { useState } from 'react';
import api from './api';

const PdfUpload = ({ onClose }) => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        // Clear previous messages when a new file is selected
        setMessage('');
        setError('');
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        // Reset messages on new submission
        setMessage('');
        setError('');

        if (!file) {
            setError('Please select a PDF file first.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            setIsLoading(true);
            setMessage('Uploading and parsing PDF...'); // Initial feedback

            const response = await api.post('/usage/upload-optus-pdf', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            // On success
            setMessage(response.data.message);
            setFile(null);
            document.getElementById('pdfFileInput').value = '';
        } catch (err) {
            // On error, use the specific message from the server
            setError(err.response?.data?.error || 'Error uploading or parsing PDF');
            setMessage(''); // Clear the "Uploading..." message
        } finally {
            // This runs after both try and catch are finished
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Upload Optus Data Usage (PDF)</h2>
                    <button className="modal-close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    <form onSubmit={handleUpload}>
                        <label className="modal-label">Select PDF File</label>
                        <input 
                            type="file" 
                            id="pdfFileInput" 
                            accept=".pdf" 
                            onChange={handleFileChange} 
                            disabled={isLoading}
                        />
                        <button 
                            type="submit" 
                            style={{ width: '100%', marginTop: '10px' }} 
                            disabled={isLoading || !file}
                        >
                            {isLoading ? 'Processing...' : 'Upload PDF'}
                        </button>
                    </form>

                    <div style={{ marginTop: '15px', textAlign: 'center', fontWeight: 'bold' }}>
                        {message && (
                            <p style={{ color: 'var(--accent-hover)', margin: 0 }}>
                                {message}
                            </p>
                        )}
                        {error && (
                            <p style={{ color: '#721c24', margin: 0 }}>
                                {error}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PdfUpload;
